export const BUCHAREST_WAREHOUSE = "Bucharest Warehouse";

export type SymphonyaOrderTone = "pending" | "skipped" | "error" | "synced";

export function canPushOrderToSymphonya(locatie: string): boolean {
  return locatie === BUCHAREST_WAREHOUSE;
}

export function symphonyaOrderStatus(code: number): {
  label: string;
  tone: SymphonyaOrderTone;
  title: string;
} {
  if(code === 0) {
    return {label: "-", tone: "pending", title: "Pending Symphonya push"};
  }
  if(code === -1) {
    return {label: "-", tone: "skipped", title: "Skipped (pre-sync order)"};
  }
  if(code === 1) {
    return {label: "ERR", tone: "error", title: "Symphonya push failed"};
  }
  return {label: `#${code}`, tone: "synced", title: `Synced — Symphonya ERP order #${code}`};
}

export function symphonyaResendButtonLabel(code: number): string {
  if(code === 1) return "Retry Symphonya";
  if(code > 1) return "Force resend";
  return "Send to Symphonya";
}

export function symphonyaResendConfirm(code: number, orderId: number): {
  title: string;
  message: string;
  confirmLabel: string;
} {
  if(code > 1) {
    return {
      title: "Force resend to Symphonya",
      message: `Order #${orderId} is already synced (ERP #${code}). Resending may create a duplicate order in Symphonya. Continue?`,
      confirmLabel: "Force resend"
    };
  }
  if(code === 1) {
    return {
      title: "Retry Symphonya",
      message: `Resend order #${orderId} to Symphonya?`,
      confirmLabel: "Retry"
    };
  }
  return {
    title: "Send to Symphonya",
    message: `Send order #${orderId} to Symphonya?`,
    confirmLabel: "Send"
  };
}

/** Admin hint when Symphonya returns plain-text/HTML access errors */
export function symphonyaErrorHint(error: string): string | null {
  if(/access denied/i.test(error) || /\bHTTP 403\b/i.test(error)) {
    return "HTTP 403 from Symphonya — the server is blocked before the JSON API (IP whitelist or hosting firewall). Open Integrations → Test connection to see this server's outbound IP, then ask Symphonya to whitelist it for createOrder POST.";
  }
  return null;
}
